import { NavDropdown } from './NavDropdown';
import { normalizeNavPath } from './navPath';

export const PRODUCT_LINKS = [
  {
    to: '/product/script-editor',
    label: 'Script',
    description: 'Turn a screenplay into a cinematic cut, shot by shot',
  },
  {
    to: '/product/ai-video-continuity',
    label: 'Continuity Engine',
    description: 'Persistent continuity across your entire timeline',
  },
  {
    to: '/product/shot-control',
    label: 'Shots',
    description: 'Director-grade camera, lighting, and pacing control',
  },
  {
    to: '/product/models',
    label: 'Models',
    description: 'Best-in-class video models, auto-routed for you',
  },
] as const;

type ProductNavDropdownProps = {
  pathname: string;
};

function isProductActive(pathname: string) {
  const path = normalizeNavPath(pathname);
  return path === '/product' || path.startsWith('/product/');
}

export function isProductNavActive(pathname: string) {
  return isProductActive(pathname);
}

export function ProductNavDropdown({ pathname }: ProductNavDropdownProps) {
  return (
    <NavDropdown
      label="Product"
      links={PRODUCT_LINKS}
      pathname={pathname}
      isActive={isProductActive}
    />
  );
}
